export default {
  'overview_daily_Daily': '运营总况日报',
  'overview_daily_DAU': '日活跃',
  'overview_daily_D2': '次留',
  'overview_daily_D2/3/7': '次留/3留/7留',
  'overview_daily_D2(T-1)': '次留(T-1)',
  'overview_daily_D3': '3留',
  'overview_daily_D7': '7留',
  'overview_daily_D14': '14留',
  'overview_daily_D21': '21留',
  'overview_daily_D28': '28留',
  'overview_daily_D30': '30留',
  'overview_daily_D4': '4留',
  'overview_daily_D5': '5留',
  'overview_daily_D6': '6留',
  'overview_daily_DAU_Retention_Users': '日活留存',
  'overview_daily_weighted_tab': '加权次留/3留/7留',
  'overview_daily_DAU_Return_Users': '日回流',
  // 'overview_daily_Weighted_D1':'Weighted D1',
  'overview_daily_Weighted_D2': '加权次留',
  'overview_daily_Weighted_D3': '加权3留',
  'overview_daily_Weighted_D7': '加权7留',
  'overview_daily_Weighted_D2_short': '加权次留',
  'overview_daily_Weighted_D3_short': '加权3留',
  'overview_daily_Weighted_D7_short': '加权7留',
  'overview_day_Weighted_2': '加权次留',
  'overview_day_Weighted_3': '加权3留',
  'overview_day_Weighted_7': '加权7留',
  'overview_daily_Weighted_D14': '加权14留',
  'overview_daily_Weighted_D21': '加权21留',
  'overview_daily_Weighted_D28': '加权28留',
  'overview_daily_Weighted_D30': '加权30留',
  'overview_daily_1st_Order_Login%': '一阶登录比',
  'overview_daily_2nd_Order_Login%': '二阶登录比',

  // v2趋势图
  'overview_daily_v2_playtime': '在线时长中位数',
  'overview_daily_v2_avg_playtime': '平均在线时长',
  'overview_daily_v2_session': '单个存档在线时长',
  'overview_daily_v2_avg_session': '单个存档平均在线时长',

  // 卡片
  'overview_daily_key_performance_metrics_explain_au': '统计周期内登录过游戏的用户数(vopenid数去重)，超过一天展示平均日活。',
  'overview_daily_key_performance_metrics_explain_new': '统计周期内新注册用户数(vopenid数去重)，超过一天展示累计新进。',
  'overview_daily_key_performance_metrics_explain_revenue': '统计周期内玩家的实际付费金额总额，超过一天展示累计付费。',
  'overview_daily_key_performance_metrics_explain_arpu': '活跃ARPU=统计周期内消费额/活跃用户数。<br/>超过一天展示平均ARPU。统计周期内消费额的和/活跃用户数的和。',
  'overview_daily_key_performance_metrics_explain_payer': '付费渗透率=统计周期内消费用户数/活跃用户数<br/>超过一天展示平均付费渗透率。统计周期内消费用户数的和/活跃用户数的和。',
  'overview_daily_key_performance_metrics_explain_d2': '前一天次留，次留=XX注册日期第2天存留用户数/XX注册日期新注册用户数，注册日期是第一天。<br/>超过一天展示平均次留，统计周期内每一天注册用户次留用户数求和/统计周期内每一天新注册用户数求和。',

  // TODO: 无
  'overview_day_retention_2': '次留',
  'overview_day_retention_3': '3留',
  'overview_day_retention_7': '7留',
  'overview_daily_Last_Week': '上周同期',
  'overview_daily_Last_Month': '上月同期',
  'overview_daily_Last_Year': '去年同期',
  'overview_daily_Today': '当天',
  'overview_daily_DAU_Breakdown': '日活跃用户构成',

  'overview_table_date': '日期',
  'overview_table_new_users': '新进用户',

  'overview_overall_performance': '指标总体表现',
  'overview_overall_performance_version': '版本对比',

  'overview_breakdown_legend1': '新进用户',
  'overview_breakdown_legend2': '留存用户',
  'overview_breakdown_legend3': '回流用户',

  'overview_area_title': '国家/区域/区服排行榜',
  'overview_area_tab_country': '国家',
  'overview_area_tab_region': '区域',
  'overview_area_tab_zone': '区服',
  'overview_area_tab_channel': '渠道',
  'overview_area_title_country': '{timeType}  Top 10 国家',
  'overview_area_title_region': '{timeType}  Top 10 区域',
  'overview_area_title_zone': '{timeType}  Top 10 区服',
  'overview_area_title_channel': '{timeType}  Top 10 渠道',
  'overview_area_title_os1': '{timeType}  Top 10 平台',
  'overview_area_active_table_header2': '{timeType}活跃',
  'overview_area_active_table_header2_avg': '{timeType}平均活跃',
  'overview_area_active_table_header3': '全局占比',

  'overview_area_revenue_table_header2_sum': '总付费金额',
  'overview_area_revenue_table_header2': '付费金额',
  'overview_area_mtx_revenue_table_header2_sum': '总内购收入',
  'overview_area_mtx_revenue_table_header2': '内购收入',
  'overview_area_new_table_header2_sum': '新进总数',
  'overview_area_units_table_header2_sum': '总本体拷贝净销量',
  'overview_area_units_table_header2': '本体拷贝净销量',
  'overview_area_net_revenue_table_header2': '收入(剔除退款&税)',
  'overview_area_net_revenue_table_header2_sum': '总收入(剔除退款&税)',
  'overview_area_new_table_header2': '新进',
  'overview_area_new_chart_share': '占比',

  // PC Console 模块
  'overview_pcconsoleday_retention_2': '次留',
  'overview_pcconsoleday_retention_3': '3留',
  'overview_pcconsoleday_retention_7': '7留',
  'overview_pcconsoleday_Weighted_2': '加权次留',
  'overview_pcconsoleday_Weighted_3': '加权3留',
  'overview_pcconsoleday_Weighted_7': '加权7留',
  'overview_area_tab_os': '平台',
  'overview_area_tab_lang': '语言',
  'overview_area_title_os': '{timeType} 平台',
  'overview_area_title_lang': '{timeType} 语言',
  // 卡片
  'pc_overview_daily_key_performance_metrics_explain_revenue': '统计周期内，销售平台合计的净销售收入，包括Steam/Epic/Playstation/Xbox等平台。Data Source：Platform Sales Reports',
  'pc_overview_daily_key_performance_metrics_explain_units': '统计周期内，游戏本体的净销售数量，包括full game，eddition等的游戏本体销量。Data Source：Platform Sales Reports',
  'pc_overview_daily_key_performance_metrics_explain_aot': '平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户。',
  'pc_overview_daily_key_performance_metrics_explain_pcu': '将当天内各时刻（每5分钟打点）的在线数进行平均统计。',
  'pc_overview_daily_key_performance_metrics_explain_dlc_mtx_revenue': '统计周期内，DLC 销售收入和游戏内购收入总金额。',
  'pc_overview_daily_key_performance_metrics_explain_mtx_revenue': '统计周期内，游戏内购收入总金额。',
  'pc_overview_daily_key_performance_metrics_explain_mtx_payer_rate': '内购付费人数/统计周期内的活跃人数。',
  'pc_overview_daily_key_performance_metrics_explain_mtx_payer': '统计期间内有付费行为的用户总数，包括游戏内付费和DLC付费（去重）。',
  'pc_overview_daily_key_performance_metrics_explain_payer': '统计期间内有付费行为的用户总数，包括游戏内付费和DLC付费（去重）。',
  'pc_overview_daily_key_performance_metrics_explain_payer%': 'DLC和内购付费人数/统计周期内的活跃人数。',
  'pc_overview_daily_key_performance_metrics_explain_dlc_mtx_arpu': 'DLC收入和内购收入/统计周期内的活跃人数。',
  'pc_overview_daily_key_performance_metrics_explain_mtx_arpu': '内购收入/统计周期内的活跃人数。',
  'pc_overview_daily_key_performance_metrics_explain_arppu': '总收入/统计周期内的DLC和内购付费人数。',
  'pc_overview_daily_key_performance_metrics_explain_dlc_mtx_arppu': 'DLC收入和内购收入/统计周期内的付费人数。',
  'pc_overview_daily_key_performance_metrics_explain_mtx_arppu': '内购收入/统计周期内的付费人数。',

  // Nightingale
  'pc_overview_daily_D1': '次留',
  'pc_overview_daily_D2': '2留',
  'pc_overview_daily_key_performance_metrics_explain_accumulated_units': '游戏上线截止至统计日期结束的游戏本体拷贝的累计销售数量。',
  'pc_overview_daily_key_performance_metrics_explain_refunded_units': '统计期间内退款的游戏本体拷贝数量。',
  'pc_overview_daily_key_performance_metrics_explain_accumulated_revenue': '游戏上线截止至统计日期结束的累计收入金额。',
  'pc_overview_daily_key_performance_metrics_explain_avg_selling_price_asp': '统计期间内游戏的平均售价。',
  'pc_overview_daily_key_performance_metrics_explain_reactivated_users': '距离上一次登录超过30天的活跃用户。',
  'pc_overview_daily_key_performance_metrics_explain_median_online_time': '统计期间内，用户在线时长的中位数。',
  'pc_overview_daily_key_performance_metrics_explain_aot_hour': '统计期间内，用户日均在线时长。',
  'pc_overview_daily_key_performance_metrics_explain_above_2hr_users': '统计期间内，在线时长超过2小的用户数。',
  'pc_overview_daily_v2_key_performance_metrics_explain_above_2hr_users': '统计期间内，在线时长超过2小的新进用户数。',
  'pc_overview_daily_key_performance_metrics_explain_median_session_time': '统计期间内，会话时长的中位数。',
  'pc_overview_daily_key_performance_metrics_explain_avg_session_time': '统计期间内日均会话时长。',
  'pc_overview_daily_key_performance_metrics_explain_avg_session_cnt': '统计期间内用户日均会话次数。',
  'pc_overview_daily_key_performance_metrics_explain_pcu_active_users_rate': '最高在线人数/每日活跃用户数',
  'pc_overview_daily_key_performance_metrics_explain_acu': '平均在线人数',
  'pc_overview_daily_key_performance_metrics_explain_stickiness': 'DAU/WAU(Last 7 days)',
  'pc_overview_daily_key_performance_metrics_explain_active_retention_d2t1': '第一天活跃用户的留存率。\\nD1：统计日起第1天的留存用户数/统计日当天的活跃用户数。\\n超过 1 天的日期显示平均 D1。 统计期内第1天留存用户总数/统计期内活跃用户总数。\\nT-1是指统计日的前一天。\\n例如统计日期T为20230806，则Day 0为20230806，Day 1为20230807；\\nT-1为20230805，D1(T-1)为20230805的D1；',
  'pc_overview_daily_key_performance_metrics_explain_active_retention_d8t7': '第 7 天的活跃用户留存率。\\nD7：统计日起第7天的留存用户数/统计日当天的活跃用户数。\\n超过 1 天的日期显示平均 D7。 统计期内第7天留存用户总数/统计期内活跃用户总数。\\nT-7是指统计日期前7天。\\n例如统计日期T为20230806，则第0天为20230806，第7天为20230813；\\nT-7为20230730，D7(T-7)为20230730的D7；',
  'pc_overview_area_mtx_revenue_table_header2_sum($)': '总内购收入({unit})',
}
